import type { FC, ReactNode } from 'react';
import { generatePath } from 'react-router';
import cn from 'classnames';
import { ROUTES } from 'router/routes';

import type { WithTestId } from 'types/app';

import { Icons } from '@Atomic/atoms/Icons';
import { LinkRouter } from '@Atomic/atoms/LinkRouter';

import styles from './profileLinkWrapper.module.scss';

type ProfileLinkWrapperProps = WithTestId<{
  children?: ReactNode;
  uuid: string;
  withIcon?: boolean;
  goto?: string;
  className?: string;
}>;

export const ProfileLinkWrapper: FC<ProfileLinkWrapperProps> = ({
  uuid,
  children,
  withIcon = false,
  goto,
  className,
  testId,
}) => (
  <LinkRouter
    className={cn(styles.linkWrapper, className)}
    to={generatePath(ROUTES.PUBLIC_PROFILE, { uuid }) + (goto ? `?goto=${goto}` : '')}
    testId={testId}
  >
    {children}
    {withIcon && <Icons.ChevronRight className={styles.icon} />}
  </LinkRouter>
);
